/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gh-job-admin-tab-container',
  templateUrl: 'job-admin-tab-container.component.html',
})
export class JobAdminTabContainerComponent {
}
